import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHookSection() {
  return <section className="py-12 md:py-24 px-4 bg-warm-50" data-id="element-155">
      <div className="max-w-3xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-157">
          <div className="space-y-5 md:space-y-6 text-lg md:text-xl text-warm-800/85 leading-relaxed font-light mb-8 md:mb-10" data-id="element-158">
            <p data-id="element-159">Sé exactamente lo que se siente.</p>
            <p data-id="element-160">
              Llegas a casa después de un día interminable de decisiones… y
              entonces aparece ella:
            </p>
          </div>

          <motion.p initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="text-3xl md:text-5xl font-heading italic text-warm-900 mb-10 md:mb-12 leading-tight" data-id="element-161">
            "¿Qué cenamos hoy?"
          </motion.p>

          <div className="space-y-5 md:space-y-6 text-base md:text-xl text-warm-800/85 leading-relaxed font-light" data-id="element-162">
            <p data-id="element-163">
              Esa pregunta no es sobre comida. Es sobre{' '}
              <strong className="text-warm-900 font-semibold not-italic" data-id="element-164">
                carga mental
              </strong>
              . Es el agotamiento de abrir la nevera, mirar un bote de garbanzos
              y un trozo de queso, y sentir ganas de llorar porque no te queda
              energía ni para decidir qué hacer con ellos.
            </p>
            <p data-id="element-165">
              Terminas pidiendo comida a domicilio por pura parálisis, gastando
              dinero que no querías gastar y comiendo algo que no te hace sentir
              bien.
            </p>
            <p className="text-warm-900 font-medium" data-id="element-166">
              El problema no es que no sepas cocinar. El problema es que ya no
              puedes tomar ni una sola decisión más.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}